import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  container: {
    flex: 1,
    borderRadius: theme.borderRadius.l,
  },

  content: ({ pressed }: { pressed: boolean }) => ({
    flex: 1,
    paddingLeft: theme.spacing[4],
    paddingVertical: theme.spacing[5],
    borderRadius: theme.borderRadius.l,
    borderWidth: 1.5,
    borderColor: pressed ? colors.backgroundL1Alpha : colors.backgroundL1,
    backgroundColor: pressed ? colors.backgroundL1Alpha : 'transparent',
  }),

  price: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    position: 'absolute',
    right: 0,
    bottom: theme.spacing[6],
    paddingVertical: theme.spacing[2],
    paddingHorizontal: theme.spacing[4],
    borderTopLeftRadius: theme.borderRadius.xs,
    borderBottomLeftRadius: theme.borderRadius.xs,
    width: 'auto',
    backgroundColor: colors.backgroundL1,
    color: colors.textBrand,
  },
}));
